import { getEnvironment } from './runtimeEnvironment';
import { getBasePath } from '../config/basePath';

/**
 * Base URL API per il modulo social.
 * In DEV locale punta al server TEST (OAuth Meta richiede HTTPS lì).
 */
export function getSocialApiBaseUrl() {
  const override = process.env.REACT_APP_SOCIAL_API_BASE_URL;
  if (override && String(override).trim() !== '') {
    return String(override).replace(/\/$/, '');
  }

  if (getEnvironment() === 'dev') {
    return 'https://test.fitgymtrack.com/api';
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const { protocol, hostname, port } = window.location;
    const portSuffix =
      port && port !== '80' && port !== '443' ? `:${port}` : '';
    return `${protocol}//${hostname}${portSuffix}/api`;
  }

  return '/api';
}

/** URL di ritorno dopo OAuth (pagina Social in Gym-2.0). */
export function getSocialReturnUrl() {
  if (typeof window === 'undefined') {
    return '';
  }

  const { protocol, hostname, port } = window.location;
  const portSuffix = port && port !== '80' && port !== '443' ? `:${port}` : '';

  // Su TEST usare sempre l'host HTTPS con certificato valido (non l'IP nudo).
  let host = hostname;
  let scheme = protocol.replace(':', '');
  if (hostname === '64.226.103.60' || hostname === '64-226-103-60.sslip.io') {
    host = 'test.fitgymtrack.com';
    scheme = 'https';
  }

  const base = getBasePath();
  const path = `${base}/gym/social`.replace(/\/{2,}/g, '/');
  return `${scheme}://${host}${portSuffix}${path}`;
}

/**
 * Upload immagine o video social (fetch nativo: evita Content-Type JSON di axios su FormData).
 * @param {File} file
 * @param {'image'|'video'} kind
 */
export async function uploadSocialMediaFile(file, kind = 'image') {
  const base = getSocialApiBaseUrl();
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('auth_token') : null;
  const form = new FormData();
  form.append(kind === 'video' ? 'video' : 'image', file);

  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${base}/gym_social_media_upload.php`, {
    method: 'POST',
    headers,
    body: form,
  });

  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok) {
    const err = new Error(data.error || 'Upload non riuscito');
    err.response = { data, status: res.status };
    throw err;
  }

  return data;
}
